module.exports = __webpack_public_path__ + "img/56.90c54210.jpg";